import { useState } from 'react';
import ConnectDocuSign from './ConnectDocuSign';
import SetupConnect from './SetupConnect';
import SendEnvelope from './SendEnvelope';

export default function Dashboard() {
  const [userId, setUserId] = useState<string | null>(localStorage.getItem('docusign_user_id'));
  const [isConnected, setIsConnected] = useState(false);

  const handleConnected = (newUserId: string) => {
    setUserId(newUserId);
    setIsConnected(true);
    localStorage.setItem('docusign_user_id', newUserId);
  };

  return (
    <div className="space-y-6">
      <div className="bg-white shadow rounded-lg p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">DocuSign Integration Dashboard</h1>
        <p className="text-gray-600 mb-6">
          Connect your DocuSign account to receive webhook notifications when documents are signed.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Step 1: Connect DocuSign */}
          <div className="border rounded-lg p-4">
            <div className="flex items-center mb-3">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-indigo-100 text-indigo-600 font-bold mr-3">
                1
              </span>
              <h2 className="text-lg font-semibold">Connect DocuSign</h2>
            </div>
            <ConnectDocuSign onConnected={handleConnected} />
          </div>

          {/* Step 2: Setup Webhook */}
          <div className="border rounded-lg p-4">
            <div className="flex items-center mb-3">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-indigo-100 text-indigo-600 font-bold mr-3">
                2
              </span>
              <h2 className="text-lg font-semibold">Setup Webhook</h2>
            </div>
            <SetupConnect userId={userId} disabled={!isConnected && !userId} />
          </div>

          {/* Step 3: Test */}
          <div className="border rounded-lg p-4">
            <div className="flex items-center mb-3">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-indigo-100 text-indigo-600 font-bold mr-3">
                3
              </span>
              <h2 className="text-lg font-semibold">Send Test Document</h2>
            </div>
            <SendEnvelope userId={userId} disabled={!isConnected && !userId} />
          </div>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white shadow rounded-lg p-6">
          <h3 className="text-sm font-medium text-gray-500">Connection Status</h3>
          <p className={`text-2xl font-bold ${isConnected || userId ? 'text-green-600' : 'text-gray-400'}`}>
            {isConnected || userId ? 'Connected' : 'Not Connected'}
          </p>
        </div>
        <div className="bg-white shadow rounded-lg p-6">
          <h3 className="text-sm font-medium text-gray-500">User ID</h3>
          <p className="text-sm font-mono text-gray-700 truncate">{userId || 'N/A'}</p>
        </div>
        <div className="bg-white shadow rounded-lg p-6">
          <h3 className="text-sm font-medium text-gray-500">Environment</h3>
          <p className="text-2xl font-bold text-indigo-600">Demo</p>
        </div>
      </div>
    </div>
  );
}
